import DOMPurify from 'dompurify';

/**
 * Sanitiza uma string HTML para prevenir ataques XSS.
 * @param html - A string HTML a ser sanitizada.
 * @returns A string HTML sanitizada.
 */
export const sanitizeHtml = (html: string): string => {
  return DOMPurify.sanitize(html, {
    ADD_TAGS: ["iframe"],
    ADD_ATTR: ["allow", "allowfullscreen", "frameborder", "scrolling", "referrerpolicy"]
  });
};
